import React, { ButtonHTMLAttributes } from "react";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import { Container, Handle, Label, Rail, Switch } from "./ToggleSwitch.styles";

interface IToggleSwitchProps
    extends
        ITestableComponentProps,
        Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
    on: boolean;
    children: string;
    showLabel?: boolean;
}

export function ToggleSwitch(props: IToggleSwitchProps) {
    const { id, on, children, showLabel = false, ...rest } = props;

    const label = showLabel ? <Label>{children}</Label> : null;
    const ariaLabel = !showLabel ? { "aria-label": children } : null;

    return (
        <Container
            id={id}
            type="button"
            $on={on}
            {...rest}
            aria-pressed={on ? "true" : "false"}
            {...ariaLabel}
        >
            {label}
            <Switch aria-hidden="true">
                <Rail aria-hidden="true" />
                <Handle aria-hidden="true" />
            </Switch>
        </Container>
    );
}
